(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sidebar"]) return;
  try {
    
const campaignLauncher = document.querySelector('.itoix-campaign-launcher');

if (campaignLauncher && campaignLauncher.parentElement !== document.body) {
    document.body.appendChild(campaignLauncher);
}

if (campaignLauncher && 'showPopover' in campaignLauncher) {
    campaignLauncher.setAttribute('popover', 'manual');

    if (!campaignLauncher.matches(':popover-open')) {
        campaignLauncher.showPopover();
    }
}

  } catch(e) { console.error(e); }
})();
})();
